import { Component, Input, OnInit } from '@angular/core';
import { FacturaService } from '../../../../services/database/factura.service';
import { IGetFacturaInfo } from '../../../../shared/interfaces/database/liquidacion';
import { DEFAULT_DATE_FORMAT } from 'lib-base';
import { CommonModule } from '@angular/common';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-factura',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './factura.component.html',
  styleUrl: './factura.component.scss'
})
export class FacturaComponent implements OnInit {

  @Input() tramRegistroId !: number;

  isLoading: boolean = true;
  data !: IGetFacturaInfo;
  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  trans: any = {};

  constructor(private readonly _fs: FacturaService, private readonly _t: TranslateService) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({      
      tipoIdentificacion: this._t.get('common.tipoIdentificacion'),
      identificacion: this._t.get('common.identificacion'),
      correo: this._t.get('common.correo'),
      telefono: this._t.get('common.telefono'),
      direccion: this._t.get('common.direccion'),
      referencia: this._t.get('common.referencia'),
      factura: this._t.get('common.factura'),
      loteFacturacion: this._t.get('common.loteFacturacion'),
      fechaRegistro: this._t.get('common.fechaRegistro'),
      fechaVencimiento: this._t.get('common.fechaVencimiento'),
      impuesto: this._t.get('common.impuesto'),
      concepto: this._t.get('common.concepto'),
      nombreTramite: this._t.get('common.nombreTramite'),
      totalPago: this._t.get('common.totalPago'),      
      informacionFactura: this._t.get('msg.informacionFactura')
    }));
  }

  //#region API Calls
  getFacturaInfo() {    
    if (!this.tramRegistroId || this.data !== undefined) 
      return;
    this.isLoading = true;
    this._fs.getFacturaInfo(this.tramRegistroId).subscribe({
      next: (data: IGetFacturaInfo) => {
        this.data = data;        
      }, complete: () => {
        this.isLoading = false;
      }
    });
  }
  //#endregion API Calls
}
